export const ADD_SR_FAMILY_MEMBER_MODAL_NAME =
  'ADD_SR_FAMILY_MEMBER_MODAL_NAME';
